import React, { useEffect, useState } from 'react'
import { Avatar, Button, Paper, Grid, Typography, Container } from "@material-ui/core"
import { useDispatch } from "react-redux"
import { useHistory } from "react-router-dom"
import { useGoogleLogin } from '@react-oauth/google';
import Icon from "./icon"
import LockOutlinedIcon from "@material-ui/icons/LockOutlined"
import useStyles from "./styles"
import Input from "./Input"
import { checkGoogleSessionToken } from '../../api';
import { signin, signup } from "../../actions/auth"
import { createScore } from '../../actions/scores'
import Lang from "../../Lang"

const initialState = { firstName: "", lastName: "", email: "", password: "", confirmPassword: "" }

const Auth = () => {
    const classes = useStyles()
    const [showPassword, setShowPassword] = useState(false)
    const [isSignup, setIsSignup] = useState(false)
    const [formData, setFormData] = useState(initialState)
    const [cuentaManual, setCuentaManual] = useState(false)
    const dispatch = useDispatch()
    const history = useHistory()

    const [user, setUser] = useState();

    const setUserData = async (user) => {
        const googleData = await checkGoogleSessionToken(user.access_token)
        dispatch({ type: "AUTH", data: { result: { ...googleData, googleId: googleData.id }, token: user.access_token } })
        dispatch(createScore({ userId: googleData.id, userName: googleData.name, email: googleData.email, puntos: "1000", category: "Michi", media: "0", mediaCinco: "0" }))
        history.push("/")
    }

    useEffect(() => {
        if (user) { setUserData(user) }
    }, [user])

    // Random Id generator for non-google user

    let guid = () => {
        let s4 = () => {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
        }
        return s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4()
    }

    // Toggle show password
    const handleShowPassword = () => setShowPassword((prevShowPassword) => !prevShowPassword)

    const handleSubmit = (e) => {
        e.preventDefault()
        formData.userId = guid()
        if (isSignup) {
            dispatch(signup(formData, history))
        } else {
            dispatch(signin(formData, history))
        }
    }

    const handleChange = (e) => {
        // Spreads properties pero solo cambia la del target value
        setFormData({ ...formData, [e.target.name]: e.target.value })
    }

    const switchMode = () => {
        setIsSignup((prevIsSignup) => !prevIsSignup)
        setShowPassword(false)
    }

    const login = useGoogleLogin({
        onSuccess: (codeResponse) => setUser(codeResponse),
        onError: (error) => console.log('Login Failed:', error)
    });

    const toggleCuentaManual = () => {
        setCuentaManual(!cuentaManual)
    }

    return (
        <Container component="main" maxWidth="xs">
            <Paper className={classes.paper} elevation={3}>
                <Avatar className={classes.avatar}>
                    <LockOutlinedIcon />
                </Avatar>
                <Typography variant="h5">{isSignup ? <Lang props={"Crear cuenta"} /> : <Lang props={"Iniciar sesión"} />}</Typography>
                {!cuentaManual && <Button
                    className={classes.googleButton}
                    color="primary"
                    fullWidth
                    onClick={() => login()}
                    disabled={false}
                    startIcon={<Icon />
                    } variant="contained">
                    Google
                </Button>}
                <Button onClick={toggleCuentaManual}>{cuentaManual ? <Lang props={"¿Prefieres cuenta de Google?"} /> : <Lang props={"¿Prefieres cuenta para mecanews?"} />} </Button>
                {cuentaManual &&
                    <form className={classes.form} onSubmit={handleSubmit}>
                        <Grid container spacing={2}>
                            {
                                isSignup && (
                                    <>
                                        <Input name="firstName" label={<Lang props={"Nombre"} />} handleChange={handleChange} autoFocus half />
                                        <Input name="lastName" label={<Lang props={"Apellidos"} />} handleChange={handleChange} half />
                                    </>
                                )
                            }
                            <Input name="email" label="Email" handleChange={handleChange} type="email" />
                            <Input name="password" label={<Lang props={"Contraseña"} />} handleChange={handleChange} type={showPassword ? "text" : "password"} handleShowPassword={handleShowPassword} />
                            {isSignup && <Input name="confirmPassword" label={<Lang props={"Repite contraseña"} />} handleChange={handleChange} type="password" />}
                        </Grid>
                        <Button type="submit" fullWidth variant="contained" color="primary" className={classes.submit} >
                            {isSignup ? <Lang props={"Crear cuenta"} /> : <Lang props={"Iniciar sesión"} />}
                        </Button>
                        <Grid container justify="flex-end">
                            <Grid item>
                                <Button onClick={switchMode}>
                                    {isSignup ? <Lang props={<Lang props={"Ya tienes cuenta?"} />} /> : <Lang props={"No tienes cuenta?"} />}
                                </Button>
                            </Grid>
                        </Grid>
                    </form>
                }
            </Paper>
        </Container>
    )
}

export default Auth
